import TruncatedText from './TruncatedText'

export default TruncatedText
